/**
 * Header info display for InspeccionDialog
 */
import React from 'react';
import { Badge } from '../ui/badge';
import { Building, User, MapPin, Calendar } from 'lucide-react';

const InspeccionHeader = ({ requerimiento }) => {
  if (!requerimiento) return null;

  const getEstadoBadge = (estado) => {
    const colors = {
      'Recibido': 'bg-blue-100 text-blue-800',
      'Inspección Programada': 'bg-purple-100 text-purple-800',
      'En Inspección': 'bg-yellow-100 text-yellow-800',
      'Inspección Terminada': 'bg-orange-100 text-orange-800',
      'En Atención': 'bg-indigo-100 text-indigo-800',
      'Cerrado': 'bg-green-100 text-green-800'
    };
    return colors[estado] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-[#FAFAFA] rounded-lg p-3 border border-[#E8E8E7]">
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <div className="flex items-center gap-1">
          <Building size={14} className="text-[#9d8272]" />
          <span className="font-medium">{requerimiento.proyecto_nombre}</span>
        </div>
        <span className="text-[#888888]">|</span>
        <div className="flex items-center gap-1">
          <MapPin size={14} className="text-[#888888]" />
          <span>{requerimiento.etapa || '-'} / {requerimiento.departamento}</span>
        </div>
        <span className="text-[#888888]">|</span>
        <div className="flex items-center gap-1">
          <User size={14} className="text-[#888888]" />
          <span>{requerimiento.cliente_nombre}</span>
        </div>
        <Badge className={`ml-auto ${getEstadoBadge(requerimiento.estado)}`}>
          {requerimiento.estado}
        </Badge>
      </div>
      <div className="flex items-center gap-2 mt-2 text-xs text-[#888888]">
        <Calendar size={12} />
        <span>Código: <strong>{requerimiento.codigo}</strong></span>
        <span className="mx-2">|</span>
        <span>Creado: {new Date(requerimiento.fecha_creacion).toLocaleDateString()}</span>
      </div>
    </div>
  );
};

export default InspeccionHeader;
